module.exports = __webpack_public_path__ + "img/upsell.2bea4fa4.svg";